// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"177":"fb5455d9","368":"1f08e166","561":"8fe5a69a","686":"32daeb26","720":"e03fbd0e","772":"76d75a02","927":"e68730fa"}[chunkId] + ".js";
};